import {BaseModule} from "system/modules/BaseModule";

declare global
{
   interface Window
   {
      moduly :Array<string>,
   }
}

export default class SystemModulesDispatcher
{

   private readonly moduleArray: Array<BaseModule>;

   constructor() {
      this.moduleArray = [];
   }

   public registerModule(module: BaseModule) :SystemModulesDispatcher {
      this.moduleArray.push(module);
      return this;
   }

   public dispatch() {
      this.moduleArray.forEach((modul :BaseModule) => {
         (async () => {
            await modul.prepare();
            const name = modul.getDatabaseEnabledName();

            if(name && !window.moduly.includes(name))
               return;

            $(modul.onReady.bind(modul));
            $(window).on('load', modul.onLoad.bind(modul));
            $(window).on('resize', modul.onResize.bind(modul));
         })();
      });

   }
}